export default{
    section:'بخش',
    impressionLocationsTitle: 'Title',
    sectionStatus: 'Status',
    impressionLocations:'Impression Locations',
    editImpressionLocations:'Edit Impression Locations',
    addImpressionLocations:'New Impression Locations ',
}